<template>
    <div
        :key="file.id"
        :class="file.is_folder ? 'folderContainer' : 'fileContainer'">
        <b-list-group-item
            v-if="!file.hidden && (currentFolder === null || file.parent_id == currentFolder.id)"
            :class="(file.is_folder ? 'is_folder ': 'is_file ') + (selectedFile !== null && selectedFile.id === file.id ? 'selected' : '')"
            @click="toggleSelected($event, file)"
            @dblclick="toggleCurrent($event, file)">
                <span class="file-name">
                    <b-icon :icon="file.is_folder ? 'folder' : 'file-earmark'"></b-icon>
                    {{ file.name }}

                    <b-badge
                        v-if="file.floor_name"
                        v-text="file.floor_name"
                        class="ml-1"
                        title="Floor"
                        v-b-tooltip.hover/>

                    <b-badge
                        v-if="showGeneratedAt && file.generated_at_date"
                        variant="danger"
                        v-text="'Generated at: ' + file.generated_at_date"
                        class="ml-1"/>
                </span>

            <div v-if="!file.is_folder" class="file-actions mt-2">
                <b-button type="button" size="sm" variant="outline-secondary"
                          v-if="hasManagerPermission('files.edit')"
                          @click.stop="showDetails(file)">Details
                </b-button>

                <b-button type="button" :disabled="!!file.is_generating" size="sm"
                          v-if="hasManagerPermission('files.edit')"
                          :variant="file.is_generating ? 'outline-danger' : 'outline-primary'"
                          class="btn-dotag-o-red"
                          @click.stop="showReplaceLayoutModal(file)">
                    <template v-if="file.is_generating">
                        <b-spinner style="width: 1rem; height: 1rem;"></b-spinner>
                        Generating
                    </template>
                    <template v-else>
                        Replace
                    </template>
                </b-button>
            </div>
        </b-list-group-item>
    </div>
</template>

<script>
export default {
    props: ['file', 'currentFolder', 'selectedFile'],
    data() {
        return {
            showGeneratedAt: true,
        };
    },
    methods: {
        showReplaceLayoutModal(file) {
            this.$emit('showReplaceLayoutModal', file);
        },
        toggleSelected(event, file) {
            this.$emit('toggleSelected', event, file);
        },
        toggleCurrent(event, file) {
            this.$emit('toggleCurrent', event, file);
        },
        showDetails(file) {
            this.$emit('showDetails', file);
        }
    },
    watch: {
        // deep watch file.generated_at
        'file': {
            handler: function (newValue, oldValue) {
                if(!newValue.is_generating && oldValue.is_generating) {
                    this.showGeneratedAt = true;
                    this.$bvToast.toast('File ' + newValue.name + ' finished generating.', {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        position: 'b-toast-bottom-right',
                    });
                }
            },
            deep: true
        }
    }

}
</script>
<style scoped>
.file-name {
    pointer-events: none;
}

.is_file {
    display: flex;
    flex-wrap: wrap;
    place-content: space-between;
    align-items: center;
}
</style>
